import { RootState } from '../../../store/store'

export const selectTree = (state: RootState) => state.tree.tree

export const selectTreeNodes = (state: RootState) => state.tree.nodes
